import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Col, Row, Space, Tag } from 'tdesign-react';
import Copyable from '@/components/Copyable';
import DescriptionItem from '@/components/DescriptionItem';
import ColTip from '@/components/Tip';

function InfoPanel({ detail }) {
  return (
    <Root>
      <Row>
        <Line xs={6} xl={4}>
          <DescriptionItem label='集群环境' value={detail.clusterEnv} />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem label='集群ID' value={detail.id} />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem
            label={<ColTip content='Pulsar集群设置的clusterName配置'>集群名称</ColTip>}
            value={detail.clusterName}
          />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem label='集群版本' value={detail.pulsarVersion} />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem label='接入时间' type='datetime' value={detail.createTime} />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem label='部署模式' value={detail.deployEnv} />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem
            label='管理员'
            value={
              <Space size={4} breakLine>
                {detail.user?.split(',').map((item, index) => (
                  <Tag key={index}>{item}</Tag>
                ))}
              </Space>
            }
          />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem label='所属应用' value={detail.app} />
        </Line>
        <Line xs={12} xl={4}>
          <DescriptionItem
            label='Function'
            value={
              detail.isOpenFunctionService ? <Copyable copy={detail.functionServiceUrl} /> : '关'
            }
          />
        </Line>
        <Line xs={6} xl={4}>
          <DescriptionItem
            label='Broker数据流URL'
            value={<Copyable copy={detail.brokerServiceUrl} />}
          />
        </Line>
        {detail.enableTlsEncryption && (
          <Line xs={6} xl={8}>
            <DescriptionItem
              label='Broker数据流URL(TLS)'
              value={<Copyable copy={detail.brokerServiceUrlTls} />}
            />
          </Line>
        )}
        <Line xs={6} xl={4}>
          <DescriptionItem
            label='Broker管理流URL'
            value={<Copyable copy={detail.brokerAdminUrl} />}
          />
        </Line>

        {detail.enableTlsEncryption && (
          <Line xs={6} xl={8}>
            <DescriptionItem
              label='Broker管理流URL(TLS)'
              value={<Copyable copy={detail.brokerAdminUrlTls} />}
            />
          </Line>
        )}

        {/* <Line xs={6} xl={4}>
          <DescriptionItem
            label='KOP'
            value={detail.isOpenKopService ? <Copyable copy={detail.kopServiceUrl} /> : '关'}
          />
        </Line> */}
      </Row>
    </Root>
  );
}

export default connect((state) => ({
  detail: state.cluster.detail,
}))(InfoPanel);

const Root = styled.div`
  padding: 12px 0 0;
`;

const Line = styled(Col)`
  display: flex;
  padding: 6px 0;
  align-items: center;
`;
